:host {
    display: flex;
    flex-direction: row;
    align-items: center;
}

:host(.okay) {
    color: var(--color-success);
}

:host(.degraded) {
    color: var(--color-warning);
}

:host(.critical) {
    color: var(--color-error);
}

es-icon {
    margin-right: 10px;
}

span {
    font-weight: 400;
}
